export function formDataCheck<T>(formData: T, defaultForm: T): boolean {
    return Object.getOwnPropertyNames(defaultForm).every((key: string) => {
        if (
            (formData[key as keyof T] === undefined || formData[key as keyof T] === '') &&
            (defaultForm[key as keyof T] === undefined || defaultForm[key as keyof T] === '')
        ) {
            return true;
        }
        if (formData[key as keyof T] instanceof Date && defaultForm[key as keyof T] instanceof Date) {
            return (formData[key as keyof T] as Date).getTime() === (defaultForm[key as keyof T] as Date).getTime();
        }
        return formData[key as keyof T] === defaultForm[key as keyof T];
    });
}
